import MenuQuestions from './MenuQuestions';
import './MenuQuestions.scss';

export default MenuQuestions;
